
import { VacationCard } from "../VacationCard";
import { VacationCardSkeleton } from "../VacationCardSkeleton";
import { ScrollToTop } from "../ScrollToTop";
import { User } from "@supabase/supabase-js";

interface WintersportResultsProps {
  loading: boolean;
  displayedVacations: any[];
  totalVacations: number;
  hasMoreResults: boolean;
  user?: User | null;
  favorites?: number[];
  onFavoriteChange?: (vacationId: number) => void;
}

export const WintersportResults = ({
  loading,
  displayedVacations,
  totalVacations,
  hasMoreResults,
  user = null,
  favorites = [],
  onFavoriteChange = () => {}
}: WintersportResultsProps) => {
  if (loading) {
    return (
      <>
        <div className="text-center py-4">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-2 text-gray-600">Wintersport vakanties laden...</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {Array.from({ length: 9 }).map((_, index) => (
            <VacationCardSkeleton key={`skeleton-${index}`} />
          ))}
        </div>
      </>
    );
  }

  return (
    <>
      <div className="text-sm text-gray-600">
        {displayedVacations.length} van {totalVacations} {totalVacations === 1 ? 'wintersport vakantie' : 'wintersport vakanties'} getoond
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {displayedVacations.map((vacation) => (
          <VacationCard
            key={vacation['product ID']}
            vacation={vacation}
            user={user}
            isFavorite={favorites.includes(vacation['product ID'])}
            onFavoriteChange={() => onFavoriteChange(vacation['product ID'])}
          />
        ))}
      </div>

      {hasMoreResults && (
        <div className="text-center text-sm text-gray-500 py-4">
          Scroll naar beneden voor meer wintersport vakanties...
        </div>
      )}

      <ScrollToTop />
    </>
  );
};
